import { useLocation } from 'react-router-dom';
import { ErrorPage as ErrorPageComponent } from '@/components/ErrorPage/ErrorPage';
import { notifyCloseModal } from '@/Utils/iframe-utils';
import { FaExclamationTriangle } from 'react-icons/fa';

/**
 * Error page route component
 * Displays error information passed via navigation state
 */
const ErrorPageRoute = () => {
  const location = useLocation();
  const state = location.state as { 
    title?: string; 
    message?: string; 
    buttonText?: string;
  } | null;

  const handleClose = () => {
    notifyCloseModal();
  };

  return (
    <ErrorPageComponent
      icon={FaExclamationTriangle}
      iconColor="#d92d20"
      title={state?.title || 'Oops! Something went wrong'}
      message={state?.message || 'We encountered an unexpected error while processing your request. Please try again later.'}
      buttonText={state?.buttonText || 'Close'}
      onButtonClick={handleClose}
    />
  );
};

export default ErrorPageRoute;
